import { AppConfig } from '../types';

export const config: AppConfig = {
  site: {
    title: "Dictionnaire énervé du Product Management",
    subtitle: "Le lexique décalé pour (sur)vivre en Product",
    author: "Pierre-Marie Brou",
    collection: "Collection Framework et frustrations"
  },

  links: {
    linkedin: "https://www.linkedin.com/in/broupm/",
    website: "https://brou.pm",
    email: "contact@brou.pm",
    bluesky: "https://bsky.app/profile/broupm.bsky.social"
  },

  features: {
    showRandomButton: true,
    enableKeyboardShortcuts: true,
    showStats: true,
    animateCards: true,
    enableModal: true
  },

  ui: {
    cardsPerRow: 3,
    maxDefinitionLength: 150,
    showLetterWatermark: true
  },

  tags: [
    { id: 'all', label: 'Tous' },
    { id: 'framework', label: 'Frameworks' },
    { id: 'métier', label: 'Métiers' },
    { id: 'concept', label: 'Concepts' },
    { id: 'agile', label: 'Agile' },
    { id: 'outil', label: 'Outils' },
    { id: 'méthodologie', label: 'Méthodologie' },
    { id: 'développement', label: 'Développement' },
    { id: 'design', label: 'Design' },
    { id: 'marketing', label: 'Marketing' },
    { id: 'metrics', label: 'Métriques' }
  ]
};
